import {DatePicker, Modal, Switch} from "antd";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import API_LINK from "../links/Link";
import Resizer from 'react-image-file-resizer';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
const dateFormat = 'YYYY-MM-DD';


export default function AppointmentModal({isVisible, setIsVisible, doctor}) {
    const [step, setStep] = useState('1');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [selectedDate, setSelectedDate] = useState('')
    const [selectedTime, setSelectedTime] = useState(null)
    const [selectedTimeHours, setSelectedTimeHours] = useState([]);

    const [selectedHour, setSelectedHour] = useState('');
    const [userInfo, setUserInfo] = useState([]);
    const [email, setEmail] = useState('');
    const [name, setName] = useState('')
    const [userName, setUserName] = useState('')
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [formType, setFormType] = useState('register')
    // Insurance
    const [isInsurance, setIsInsurance] = useState(true);
    const [base64Image, setBase64Image] = useState('');

    const loadUserInfo = async () => {
        if (localStorage.getItem("UserId")) {
            setFormType("login");
            setIsLoggedIn(true);
            setEmail(localStorage.getItem("Email"))
            setPassword(localStorage.getItem("Password"))
        }
    }

    useEffect(() => {
        loadUserInfo();
        setSelectedTime('');
    }, []);


    const submitNext = async () => {
        try {
            if (!selectedDate) toast.warning('Please fill the date'); else if (!selectedTime) toast.warning('Please select a time slot'); else {
                let sd = new Date(selectedDate);
                let d = new Date();
                let nextDate = new Date(d);
                nextDate.setDate(d.getDate() + 1);
                console.log(sd.toLocaleDateString());
                console.log(d.toLocaleDateString());
                console.log(nextDate);

                if (sd.toLocaleDateString() === d.toLocaleDateString()) {
                    toast.warning(() => {
                        return <p>Because the selected appointment is very soon, please call the office at <br/> <a
                            href="tel:6788558173">678-855-8173</a> to see if it is available.</p>
                    });
                } else if (sd.toLocaleDateString() === nextDate.toLocaleDateString()) {
                    toast.warning(() => {
                        return <p>Because the selected appointment is very soon, please call the office at <br/> <a
                            href="tel:6788558173">678-855-8173</a> to see if it is available.</p>
                    });
                } else {
                    if (localStorage.getItem("UserId") && localStorage.getItem("UserName")) {
                        await submitAppointment();
                    } else {
                        setStep('2');
                    }
                }
                //
            }

        } catch (error) {
            console.log(error)
        }
    }

    const submitAppointment = async () => {
        try {
            if (!localStorage.getItem("UserId")) {
                if (formType === 'register') {
                    if (!name) toast.warning('Please fill the name'); else if (!userName) toast.warning('Please fill the user name'); else if (!email) toast.warning('Please fill the email'); else if (!phone) toast.warning('Please fill the phone'); else if (!password) toast.warning('Please fill the password');
                } else {
                    if (!email) toast.warning('Please fill the email'); else if (!password) toast.warning('Please fill the password');
                }
            }
            if (email && password) {
                const toaster = toast.loading("Processing...");
                const formdata = new FormData();
                formdata.append("page", "SaveAppointment");
                formdata.append("image", base64Image);
                formdata.append("email", localStorage.getItem("UserId") ? localStorage.getItem("Email") : email);
                formdata.append("name", name);
                formdata.append("username", userName);
                formdata.append("phone", phone);
                formdata.append("password", localStorage.getItem("UserId") ? localStorage.getItem("Password") : password);
                formdata.append("type", formType);
                formdata.append("doctor", JSON.stringify(doctor));
                formdata.append("docMail", doctor.email);
                formdata.append("docName", doctor.name);
                formdata.append("time", JSON.stringify(selectedTime));
                formdata.append("date", selectedDate.toString());


                var requestOptions = {
                    method: 'POST', body: formdata, redirect: 'follow'
                };

                fetch(`${API_LINK}Appointment.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {
                            setTimeout(() => {
                                toast.update(toaster, {
                                    type: "success",
                                    render: "Appointment Submitted a member of our team will confirm this appointment.",
                                    isLoading: false,
                                    autoClose: toaster,
                                    closeButton: true,
                                    pauseOnHover: false,
                                    pauseOnFocusLoss: false,
                                })
                                setName('')
                                setUserName('')
                                setEmail('')
                                setPhone('')
                                setPassword('')
                                setSelectedDate('')
                                setSelectedTime('')
                                setFormType('register');
                                setIsVisible(false);
                            }, 1000)
                        } else if (result.status === 2) {
                            toast.update(toaster, {
                                type: "warning",
                                render: result.message,
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })
                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            }
        } catch (e) {
            console.log(e);
        }
    }


    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            resizeAndConvertToBase64(file);
        }
    };

    const resizeAndConvertToBase64 = (file) => {
        Resizer.imageFileResizer(file, // the file to be resized
            500, // max width
            500, // max height
            'JPEG', // output format
            90, // quality (0 to 100)
            0, // rotation
            (uri) => {
                // uri is the base64 string after resizing
                setBase64Image(uri);
                console.log(uri); // You can save this string to your database
            }, 'base64' // output type
        );
    };
    const minDate = dayjs().startOf('day');
    return (<>
        <Modal
            centered={true}
            destroyOnClose={true}
            width={window.innerWidth > 780 ? step === '1' ? "50%" : "30%" : "100%"} title={'Appointment Details'}
            zIndex={999} onCancel={() => setIsVisible(false)} footer={null}
            open={isVisible} onClose={() => setIsVisible(false)}>
            {step === '1' && <>
                <h2 className={'text-center'}>Select Appointment Date & Time</h2>
                <DatePicker onChange={(d, dateString) => {
                    setSelectedDate(dateString.toString())
                    // setSelectedDate(dateString.toString());
                }} disabledDate={(current) => current && current < minDate}
                />
                <h4 style={{marginTop: 10,}}>Available Time:</h4>
                <div className="time-container">
                    {doctor.availableTime.map((time, index) => {
                        return (<button key={index}
                                        className={`time ${selectedTime && selectedTime.day === time.day ? 'active' : null}`}
                                        onClick={() => {
                                            setSelectedTime(time);
                                            setSelectedHour('');
                                            setSelectedTimeHours(time.hours);
                                            console.log(time.hours);
                                        }}
                        >
                            <div>
                                <span>{time.day}</span>
                                <span> {time.time}</span>
                            </div>
                            <p>{time.type}</p>
                        </button>)
                    })}
                </div>
                {
                    selectedTimeHours.length > 0 &&
                    <>
                        <h4 style={{marginTop: 10,}}>Available Hours:</h4>
                        <div className="time-container">
                            {selectedTimeHours.map((hour, index) => {
                                return (<button key={index}
                                                className={`time ${selectedHour === hour ? 'active' : null}`}
                                                onClick={() => {
                                                    console.log(selectedTime);
                                                    setSelectedTime(prev => ({...prev,hour}));
                                                    setSelectedHour(hour);
                                                }}
                                >
                                    <div>
                                        <span>{hour}</span>
                                    </div>
                                </button>)
                            })}
                        </div>
                    </>
                }

                <div className="row" style={{marginTop: 15,}}>
                    <div className="form-group">
                        <label>Do you have insurance?</label>
                        <Switch checkedChildren="Yes" unCheckedChildren="No" defaultChecked
                                onChange={(s) => setIsInsurance(s)} style={{width: 70}}/>
                    </div>
                    {isInsurance && <div className="form-group">
                        <input type="file" accept="image/*" onChange={handleImageUpload}/>
                    </div>}
                </div>
                <div className="row">
                    <div className="form-group">
                        <button className='btn-submit'
                                onClick={submitNext}>{localStorage.getItem("UserId") ? "Submit" : "Next"}</button>
                    </div>
                </div>
                {/*<button className={'btn-appointment'} style={{marginTop: 20}}>Next</button>*/}
            </>}
            {step === '2' && <>
                {formType === 'login' ? <>
                    <form>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>E-mail <code>*</code></label>
                                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                           placeholder={'Enter your e-mail'}
                                           name={'email'} required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Password <code>*</code></label>
                                    <input type="password" value={password}
                                           onChange={(e) => setPassword(e.target.value)}
                                           placeholder={'Enter your password'}
                                           name={'password'} required/>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row justify-content-end">
                        <button className={'btn-link'} onClick={() => setFormType("register")}>Don't have an
                            account? Register Now
                        </button>
                    </div>
                </> : <>
                    <form>
                        <div className="row">

                            <div className="col-12">
                                <div className="form-group">
                                    <label>Name <code>*</code></label>
                                    <input type="text" value={name} onChange={(e) => setName(e.target.value)}
                                           placeholder={'Enter Name'}
                                           name={'name'}
                                           required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>User Name <code>*</code></label>
                                    <input type="text" value={userName}
                                           onChange={(e) => setUserName(e.target.value)}
                                           placeholder={'Enter User Name'}
                                           name={'username'} required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>E-mail <code>*</code></label>
                                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                           placeholder={'Enter your e-mail'}
                                           name={'email'} required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Phone No. <code>*</code></label>
                                    <input type="text" minLength={'11'} value={phone}
                                           onChange={(e) => setPhone(e.target.value)}
                                           placeholder={'Enter Phone No'}
                                           name={'phone'} required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Password <code>*</code></label>
                                    <input type="password" value={password}
                                           onChange={(e) => setPassword(e.target.value)}
                                           placeholder={'Enter your password'}
                                           name={'password'} required/>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row justify-content-end">
                        <button className={'btn-link'} onClick={() => setFormType('login')}>Already have an
                            account?
                            Login
                        </button>
                    </div>
                </>}

                <div className="row justify-content-between">
                    <button className='btn-back' onClick={() => setStep('1')}>Back</button>
                    <button className='btn-submit' onClick={submitAppointment}>Submit</button>
                </div>
            </>}
        </Modal>
    </>)
}
